//@flow

import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar, NavItem, NavLink, } from 'reactstrap';

import config from '../../config';
import makeUrl from '../../lib/makeUrl';

import FlightsDropdown from '../../components/TopBar/FlightsDropdown';
import SlidingMenu from './SlidingMenu';

type Props = {
  onLogin: () => void,
  onSignup: () => void,
  isLoggedIn: boolean,
};

const headerHeight = 60;

export default function Header(props: Props) {
  const { onLogin, onSignup, isLoggedIn } = props;
  const { goToGuideListings, goToTreks, goToLodge, goToTransportation, goToBlog } = makeUrl;
  const [hidden, setHidden] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > headerHeight) return setHidden(true);
    return setHidden(false);
  };

  useEffect(() => {
    if (window.scrollY > headerHeight) setHidden(true);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`header ${hidden ? 'fix-head' : ''}`}>
      <div className="container">
        <div className="row">
          <div className="col">
            <Navbar light expand="lg" className="nav-style-2">
              <span style={{ width: '36px' }} />
              <Link to="/">
                <img
                  className="header-logo"
                  src={`${config.ASSETS_URL}/logo-white.png`}
                  alt="HoneyGuide"
                />
              </Link>
              <SlidingMenu onLogin={onLogin} onSignup={onSignup} isLoggedIn={isLoggedIn} />
              <Nav navbar className="ml-auto d-none d-lg-flex">
                <Link to={goToTreks}>
                  <NavItem>Tours</NavItem>
                </Link>
                <FlightsDropdown homepage />
                <Link to={goToLodge}>
                  <NavItem>Lodges</NavItem>
                </Link>
                <a href={goToGuideListings}>
                  <NavItem>Guides</NavItem>
                </a>
                <Link to={goToTransportation}>
                  <NavItem>Transport</NavItem>
                </Link>
                <a href={goToBlog}>
                  <NavItem>Blog</NavItem>
                </a>

                {!isLoggedIn && (
                  <Fragment>
                    <NavItem>
                      <NavLink className="btn btn-sm" onClick={onLogin}>Log In</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className="btn btn-sm btn-outline-light"
                        onClick={onSignup}
                      >Sign Up</NavLink>
                    </NavItem>
                  </Fragment>
                )}
              </Nav>
            </Navbar>
          </div>
        </div>
      </div>
      <div className="hidden-elements">
        <svg viewBox="0 0 266.781 300">
          <defs>
            <clipPath
              id="honeyguide-hexagon"
              clipPathUnits="objectBoundingBox"
              transform="scale(0.00374839287 0.00333333)"
            >
              <path d="M12.959,229.112c-4.763-2.75-8.671-9.5-8.685-15L3.96,85.26c-0.014-5.5,3.878-12.241,8.648-14.979 L124.355,6.126c4.77-2.738,12.569-2.729,17.333,0.021l112.134,64.74c4.763,2.75,8.671,9.5,8.685,15l0.314,128.853 c0.014,5.5-3.878,12.241-8.648,14.979l-111.747,64.154c-4.77,2.738-12.569,2.729-17.333-0.021L12.959,229.112z" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Landing/Header.jsx